/**
 * Created by lihanying on 2018/1/3.
 */
import React from 'react'
import { Tooltip } from 'antd'
//回合消费
const col_bout = [
  {
    title: '对手',
    dataIndex: 'winner',
    key: 'winner',
  },
  {
    title: '账号',
    dataIndex: 'account',
    key: 'account',
  },
  {
    title: '用户',
    dataIndex: 'nickname',
    key: 'nickname',
  },
  {
    title: '球台',
    dataIndex: 'table_name',
    key: 'table_name',
  },
  {
    title: '开始时间',
    dataIndex: 'start_time',
    key: 'start_time',
  },
  {
    title: '结束时间',
    dataIndex: 'time',
    key: 'time',
  },
  {
    title: '数量',
    dataIndex: 'num',
    key: 'num',
  },
  {
    title: '总金额',
    dataIndex: 'price',
    key: 'price',
  },
  {
    title: '原价',
    dataIndex: 'origin_price',
    key: 'origin_price',
  },
  {
    title: '单价',
    dataIndex: 'uprice',
    key: 'uprice',
  },
  {
    title: '奖金',
    dataIndex: 'profit',
    key: 'profit',
  },
]
//商品消费
const col_commodity = [
  {
    title: 'id',
    dataIndex: 'id',
    key: 'id',
  },
  {
    title: '账号',
    dataIndex: 'account',
    key: 'account',
  },
  {
    title: '用户',
    dataIndex: 'nickname',
    key: 'nickname',
  },
  {
    title: '商品名称',
    dataIndex: 'c_name',
    key: 'c_name',
  },
  {
    title: '球台',
    dataIndex: 'table_name',
    key: 'table_name',
  },
  {
    title: '购买时间',
    dataIndex: 'time',
    key: 'time',
  },
  {
    title: '数量',
    dataIndex: 'num',
    key: 'num',
  },
  {
    title: '单价',
    dataIndex: 'uprice',
    key: 'uprice',
  },
  {
    title: '总金额',
    dataIndex: 'price',
    key: 'price',
  },
]

const col_service = [
  {
    title: 'id',
    dataIndex: 'id',
  },
  {
    title: '账号',
    dataIndex: 'account',
  },
  {
    title: '用户',
    dataIndex: 'memberName',
  },
  {
    title: '球台',
    dataIndex: 'tableTitle',
  },
  {
    title: '开始时间',
    dataIndex: 'startTime',
  },
  {
    title: '结束时间',
    dataIndex: 'endTime',
  },
  {
    title: '服务',
    dataIndex: 'identityType',
  },
  {
    title: '服务员',
    dataIndex: 'employeeName',
  },
  {
    title: '时长',
    dataIndex: 'duration',
  },
  {
    title: '总金额',
    dataIndex: 'amount',
  },
  {
    title: '单价',
    dataIndex: 'unitAmount',
  },
]

//战豆详情
const col_bean = [
  {
    title: '本人账号',
    dataIndex: 'account',
    key: 'account',
  },
  {
    title: '对手账号',
    dataIndex: 'opponent',
    key: 'opponent',
  },
  {
    title: '球台',
    dataIndex: 'table_name',
    key: 'table_name',
  },
  {
    title: '交割',
    dataIndex: 'amount',
    key: 'amount',
    render: (text, record, index) => (
      <span>
        {record.win === true ? '+' : '-'}
        {record.amount}
      </span>
    ),
  },
  {
    title: '开始时间',
    dataIndex: 'start_time',
    key: 'start_time',
  },
  {
    title: '结束时间',
    dataIndex: 'end_time',
    key: 'end_time',
  },
  {
    title: '流水号',
    dataIndex: 'serial_number',
    key: 'serial_number',
  },
]
//场上玩家
const col_player = [
  {
    title: '球台',
    dataIndex: 'tname',
    key: 'tname',
  },
  {
    title: '开始时间',
    dataIndex: 'start_time',
    key: 'start_time',
  },
  {
    title: '结束时间',
    dataIndex: 'time',
    key: 'time',
  },
  {
    title: '上场玩家',
    dataIndex: 'winner_fnickname',
    key: 'winner_fnickname',
    render: (text, record) => {
      if (record.wnickname === record.fnickname) {
        return (
          <div>
            <Tooltip placement="topLeft" title={record.fnickname}>
              {record.faccount}
            </Tooltip>
          </div>
        )
      } else {
        return (
          <div>
            <p>
              <Tooltip placement="topLeft" title={record.wnickname}>
                {record.waccount}
              </Tooltip>
            </p>
            <p>
              <Tooltip placement="topLeft" title={record.fnickname}>
                {record.faccount}
              </Tooltip>
            </p>
          </div>
        )
      }
    },
  },
  {
    title: '计钟玩家',
    dataIndex: 'faccount',
    key: 'faccount',
    render: (text, record) => (
      <div>
        <Tooltip placement="topLeft" title={record.fnickname}>
          {record.faccount}
        </Tooltip>
      </div>
    ),
  },
  {
    title: '时长',
    dataIndex: 'num',
    key: 'num',
  },
  {
    title: '总金额',
    dataIndex: 'price',
    key: 'price',
  },
  {
    title: '单价',
    dataIndex: 'uprice',
    key: 'uprice',
  },
  {
    title: '奖金',
    dataIndex: 'profit',
    key: 'profit',
  },
  {
    title: '串台',
    dataIndex: 'ctname',
    key: 'ctname',
  },
  {
    title: '暂停',
    dataIndex: 'status',
    key: 'status',
  },
]
//场上玩家商品消费
const col_ply_commodity = [
  {
    title: '用户昵称',
    dataIndex: 'nickname',
    key: 'nickname',
  },
  {
    title: '商品名',
    dataIndex: 'cname',
    key: 'cname',
  },
  {
    title: '台名',
    dataIndex: 'tname',
    key: 'tname',
  },
  {
    title: '购买时间',
    dataIndex: 'time',
    key: 'time',
  },
  {
    title: '数量',
    dataIndex: 'num',
    key: 'num',
  },
  {
    title: '总金额',
    dataIndex: 'price',
    key: 'price',
  },
  {
    title: '单价',
    dataIndex: 'uprice',
    key: 'uprice',
  },
]
const col_revenue = [
  {
    title: '结算日期',
    dataIndex: 'startTime',
    width: 150,
  },
  {
    title: '营业实收',
    dataIndex: 'incomeSummary',
    width: 200,
  },
  {
    title: '线上支付结算',
    dataIndex: 'balanceClub',
    width: 200,
  },
  {
    title: '当天提现/分账',
    dataIndex: 'walletClubWithdrawal',
    width: 200,
  },
  {
    title: '线上支付占比%',
    dataIndex: 'ratioIncomeThirdParty',
    width: 200,
  },
  {
    title: '桌台费',
    dataIndex: 'incomeRentTableTotal',
    width: 200,
  },
  {
    title: '棋牌房费',
    dataIndex: 'incomeRentMahjongTotal',
    width: 200,
  },
  {
    title: '飞镖机',
    dataIndex: 'incomeRentDartTotal',
    width: 200,
  },
  {
    title: '预订',
    dataIndex: 'incomeReservationTotal',
    width: 200,
  },
  {
    title: '商品销售',
    dataIndex: 'incomeCommodity',
    width: 200,
  },
  {
    title: '服务费',
    dataIndex: 'incomeServiceTotal',
    width: 200,
  },
  {
    title: '会员充值',
    dataIndex: 'incomeRecharge',
    width: 200,
  },
  {
    title: '卡券销售',
    dataIndex: 'incomeRechargeCoupon',
    width: 200,
  },
  {
    title: '定时',
    dataIndex: 'incomeTiming',
    width: 200,
  },
  {
    title: '团购',
    dataIndex: 'incomeGroupOn',
    width: 200
  },
  {
    title: '其他',
    dataIndex: 'incomeOther',
    width: 200,
  },
  {
    title: '按分类合计',
    dataIndex: 'incomeTotalByClz',
    width: 200,
    className: 'table-col',
  },
  {
    title: '现金',
    dataIndex: 'incomeCash',
    width: 200,
  },
  {
    title: '线上支付',
    dataIndex: 'incomeThirdPartyTotal',
    width: 200,
  },
  {
    title: '银行卡',
    dataIndex: 'incomeCard',
    width: 200,
  },
  {
    title: '第三方',
    dataIndex: 'incomeThirdParty',
    width: 200,
  },
  {
    title: '自定价',
    dataIndex: 'incomeCustomized',
    width: 200
  },
  {
    title: '按支付合计',
    dataIndex: 'incomeTotalByPaying',
    width: 200,
    className: 'table-col',
  },
  {
    title: '签单',
    dataIndex: 'signing',
    width: 200,
  },
  {
    title: '会员充值消耗',
    dataIndex: 'balanceMemberConsumed',
    width: 200,
  },
  {
    title: '分润',
    dataIndex: 'benefit',
    width: 200,
  },
  {
    title: '退款',
    dataIndex: 'refund',
    width: 200,
  },
  {
    title: '会员奖金',
    dataIndex: 'feeMemberRewards',
    width: 200,
  },
  {
    title: '线上支付手续费',
    dataIndex: 'feeThirdPartyTotal',
    width: 200,
  },
  {
    title: '平台费',
    dataIndex: 'feePlatform',
    width: 200,
  },
  {
    title: '当天欠费',
    dataIndex: 'debt',
    width: 200,
  },
  {
    title: '累计欠费',
    dataIndex: 'debtAdditionalTotal',
    width: 200,
  },
]

export {
  col_revenue,
  col_bout,
  col_commodity,
  col_service,
  col_bean,
  col_player,
  col_ply_commodity,
}



// WEBPACK FOOTER //
// ./src/components/CommonTable/columns.js